const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaSelect: [],
    listaSolicitacao: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'ENTREGA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'ENTREGA_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'ENTREGA_LISTADO':
            return {
                ...state, 
                lista: action.payload.data,
                listaSelect: action.payload.data.map(item => ({
                    id: item.id,
                    valor: item.nome
                }))
            };

        case 'ENTREGA_SOLICITACAO_LISTADO':
            return {
                ...state, 
                listaSolicitacao: action.payload.data
            };
            
        default:
            return state;
    }
}
